import React from 'react';
import logo from './logo.svg';
import './App.css';
import Messenger from './components/Messenger';

function App() {
  return (
    <div className="App">
     <Messenger />
    </div>
  );
}

export default App;
